import { FC } from "react";
import { useTranslation } from "react-i18next";

interface CustomCheckboxProps {
    labelKey: string;
    checked: boolean;
    disabled?: boolean;
    onClick: () => void;
    className?: string;
}

const CustomCheckbox: FC<CustomCheckboxProps> = (props) => {
    const { t } = useTranslation();

    const handleClick = () => {
        if (!props.disabled) {
            props.onClick();
        }
    };

    return (
        <div className="flex items-center space-x-2 select-none">
            <div
                onClick={handleClick}
                className={`relative w-6 h-6 border-2 border-orange-500 rounded-md cursor-pointer transition duration-200
                    ${props.checked ? "bg-orange-500" : "bg-white"}
                    ${props.disabled ? "opacity-50 cursor-not-allowed" : ""}
                    shadow-sm hover:shadow-md
                    ${props.className}`}
                style={{ minWidth: "1.5rem", minHeight: "1.5rem" }}
            >
                {props.checked && (
                    <svg
                        className="absolute inset-0 m-auto"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        stroke="white"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <polyline points="5 11 9 15 15 7" />
                    </svg>
                )}
            </div>
            {props.labelKey && (
                <span className={`text-gray-800 font-medium ${props.disabled ? "opacity-50" : ""}`}>
                    {t(props.labelKey)}
                </span>
            )}
        </div>
    );
};

export default CustomCheckbox;
